import { useMutation, useQueryClient } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import axios from "axios";

const addStep = async (data) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios
    .post(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=addStepRecording&companyid=${user.companyid}`,
      data,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response?.data?.error);
      throw error; // 🔥 REQUIRED for React Query to detect failure
    });

  return response;
};

const useAddStepQuery = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addStep,
    onSuccess: () => {
      queryClient.invalidateQueries(["testCaseResults"]);
    },
    onError: (error) => {
      console.log("Error uploading file", error.message);
    },
  });
};

export default useAddStepQuery;
